

import React from 'react';
import { Form, Input, Checkbox, Spin, Button } from 'antd';

const onFinish = (props, values, { resetFields, setFields }, history) => {
  const { registerUser, location } = props;
  const { password, confirmPassword } = values;
  if (password !== confirmPassword) {
    setFields([
      {
        name: 'password',
        errors: ['password and repeat password are not same !'],
      },
      {
        name: 'confirmPassword',
        errors: ['password and repeat password are not same !'],
      }
   ]);
  } else {
    registerUser(values).then(() => {
      const { state } = location || {};
      const { redirectUrl } = state || {};
      redirectUrl && history.push(redirectUrl);
    });
  }
  
};

const onFinishFailed = (errorInfo) => {
  console.log('Failed:', errorInfo);
};

const SignUp = (props) => {
  const { history, user } = props;
  const { loading } = user;
  const [form] = Form.useForm();
  return (
    <div>
      <section className="sign-up-page login-page">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-lg-8 col-md-12 mx-auto">
              <div className="row">
                <div className="col-lg-6 col-md-7">
                  <div className="form-wraper">
                    <h3 className="text-center">Welcome at iCause</h3>
                    <p className="text-center">Sign up for your Account</p>
                    <Spin spinning={loading}>
                      <Form
                        form={form}
                        layout="vertical"
                        name="basic"
                        onFinish={(values) => onFinish(props, values, form, history)}
                        onFinishFailed={onFinishFailed}
                      >
                        <div className="form-group">
                          <Form.Item
                            label='First Name'
                            name="fname"
                            rules={[
                              {
                                required: true,
                                message: 'Please input first name!',
                              },
                            ]}>
                            <Input placeholder='e.g: Mark' />
                          </Form.Item>
                        </div>
                        <div className="form-group">
                          <Form.Item
                            label='Last Name'
                            name="lname"
                            rules={[
                              {
                                required: true,
                                message: 'Please input last name!',
                              },
                            ]}>
                            <Input placeholder='e.g: Carson' />
                          </Form.Item>
                        </div>
                        <div className="form-group">
                          <Form.Item
                            label='Email'
                            name="email"
                            rules={[
                              {
                                required: true,
                                message: 'Please input email!',
                              },
                            ]}>
                            <Input type='email' placeholder='markcarson@example.com' />
                          </Form.Item>
                        </div>
                        <div className="form-group">
                          <Form.Item
                            label='Password'
                            name="password"
                            rules={[
                              {
                                required: true,
                                message: 'Please input password!',
                              }
                            ]}>
                            <Input autoComplete='on' type='password' placeholder='password' />
                          </Form.Item>
                        </div>
                        <div className="form-group">
                          <Form.Item
                            label='Confirm Password'
                            name="confirmPassword"
                            rules={[
                              {
                                required: true,
                                message: 'Please confirm password!',
                              }
                            ]}>
                            <Input autoComplete='on' type='password' placeholder='confirm password' />
                          </Form.Item>
                        </div>
                        <div className="form-group">
                          <Form.Item
                            label='Phone Number'
                            name="phoneNumber"
                            rules={[
                              {
                                required: true,
                                message: 'Please enter phone number!',
                              },
                            ]}>
                            <Input placeholder='e.g. (+370) 123 435 21' />
                          </Form.Item>
                        </div>
                        <div className="form-group">
                          <Form.Item
                            name="termsAndConditionsAgreed"
                            valuePropName="checked"
                            rules={[
                              {
                                required: true,
                                message: 'Please agree to terms and conditions!',
                              },
                            ]}>
                            <Checkbox style={{ fontSize: '11px' }}>
                              Creating an account means you agree with <br></br>
                              TERMS AND CONDITIONS, PRIVACY & POLICY
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <button className="btn btn-success   text-uppercase mt-4 d-block w-100" htmltype='submit'>SIGN UP</button>
                        <p className="text-center my-text mt-3">Already have an Account? 
                          <span className="text-grn">
                            <Button style={{ marginLeft: '30px', paddingTop: '8px' }} onClick={() => history.push('/auth/login')} type='link'>Sign in</Button>
                          </span>
                        </p>
                      </Form>
                    </Spin>
                  </div>
                </div>
                <div className=" col-lg-6 col-md-5">
                  <div className="social-button">
                    <div className="btn-wrper mt-3">
                      <button type="button" className="btn btn-primary bg">Sign in with Facebook</button> <span className="btn-icon"><img src="/images/fb-icon.png" className="img-fluid" alt="" /></span> </div>
                    <div className="btn-wrper mt-2">
                      <button type="button" className="btn btn-primary bg-2">Sign in with Google</button><span className="btn-icon"><img src="/images/google-icon.png" className="img-fluid" alt="" /> </span></div>
                    <div className="text-mob"> <span className="after-line">OR</span> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SignUp;
